import Api from '@/services/Api'

const URL = 'cat/proveedores/';

export default {
    
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('codigo' in params) {
            return Api().put(url + params.codigo + '/', params)
        }
        return Api().post(url, params)
    }
}